<template>
  <div class="space-layer">
    <light-header></light-header>
    <div class="space-content auto">
      <div class="menu-content auto">
        <div class="menu">
          <el-menu :default-active="onRoutes" router class="el-menu-vertical" @open="handleOpen" @close="handleClose"
            @select="handleSelect" :unique-opened="false" :default-openeds="['/user']">
            <el-submenu index="/user">
              <template slot="title">
                <span class="first-menu">个人中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user/info">
                  <template>
                    <div class="flex-center">
                      <svg-icon iconClass="menu-account" class="menu-icon"></svg-icon>
                      <svg-icon iconClass="menu-account-active" class="menu-icon active"></svg-icon>
                    </div><span class="menu-text">用户信息</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user/company-info" v-if="userInfo.userType == 'company'">
                  <template>
                    <div class="flex-center">
                      <svg-icon iconClass="menu-company" class="menu-icon"></svg-icon>
                      <svg-icon iconClass="menu-company-active" class="menu-icon active"></svg-icon>
                    </div><span class="menu-text">企业信息</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user/contact">
                  <template>
                    <div class="flex-center">
                      <svg-icon iconClass="menu-contact" class="menu-icon"></svg-icon>
                      <svg-icon iconClass="menu-contact-active" class="menu-icon active"></svg-icon>
                    </div><span class="menu-text">通讯录</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user/bill">
                  <template>
                    <div class="flex-center">
                      <svg-icon iconClass="menu-bill" class="menu-icon"></svg-icon>
                      <svg-icon iconClass="menu-bill-active" class="menu-icon active"></svg-icon>
                    </div><span class="menu-text">账单中心</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user/settings">
                  <template>
                    <div class="flex-center">
                      <svg-icon iconClass="menu-setting" class="menu-icon"></svg-icon>
                      <svg-icon iconClass="menu-setting-active" class="menu-icon active"></svg-icon>
                    </div><span class="menu-text">通用设置</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user/seal" v-if="userInfo.userType == 'person'">
                  <template>
                    <div class="flex-center">
                      <svg-icon iconClass="menu-process" class="menu-icon"></svg-icon>
                      <svg-icon iconClass="menu-process-active" class="menu-icon active"></svg-icon>
                    </div><span class="menu-text">签章管理</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>

        <div class="space-list">
          <router-view :space="userScope.spaceType"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lightHeader from "@/components/lightHeader";
import { getUserInfoApi } from "@/api/home";
import { contractCountApi } from "@/api/space/contracts";
import { getSpaceDetailInfo } from "@/api/home";
import { mapState } from "vuex";
export default {
  components: {
    lightHeader,
  },
  data() {
    return {
      userScope: { spaceType: 'company' },
      authIcons: [
        require("../../assets/images/authed.png"),
        require("../../assets/images/not-auth.png"),
      ],
      authUserHeaderImgs: [
        require("../../assets/images/index/user1-icon.png"),
        require("../../assets/images/index/user2-icon.png"),
      ]
    };
  },
  computed: {
    onRoutes() {
      let path;
      if (this.$route.query.status) {
        path = this.$route.path + "?status=" + this.$route.query.status;
      } else {
        path = this.$route.path;
      }
      return path;
    },
    idCard() {
      var str1 = "";
      if (this.userInfo.idCard) {
        str1 = this.userInfo.idCard.replace(
          /(\d{1})(\d+)(\d{1})/,
          function (x, y, z, p) {
            var i = "";
            while (i.length < z.length) {
              i += "*";
            }
            return y + i + p;
          }
        );

        return str1;
      }
    },
    phone() {
      var str1 = "";
      if (this.userInfo.phone) {
        str1 = this.userInfo.phone.replace(
          /(\d{3})(\d+)(\d{4})/,
          function (x, y, z, p) {
            var i = "";
            while (i.length < z.length) {
              i += "*";
            }
            return y + i + p;
          }
        );

        return str1;
      }
    },
    userContractInfoAall() {
      let sum = 0;
      Object.keys(this.userContractInfo).map((_key => {
        sum += Number(this.userContractInfo[_key]);
      }))
      return sum;
    },
    ...mapState(["userInfo", "userContractInfo"]),
  },
  mounted() {
    this.handleGetSpaceDetailInfo();
    this.getContractCount();
    // this.$bus.$on("emitSpaceChange", (data) => {
    //   this.handleGetSpaceDetailInfo();
    //   this.getContractCount();
    // });
  },
  // beforeDestroy() {
  //   //销毁监听事件
  //   this.$bus.$off("emitSpaceChange");
  // },
  methods: {
    handleLaunchTask() {
      this.$router.push({
        path: "/temp-create",
        query: {
          from: this.$route.fullPath.replace(/\?/, "!!"),
        },
      });
    },
    handleCart() {
      this.$router.push({
        path: "/cart/cart",
      });
    },
    handleGetSpaceDetailInfo() {
      getSpaceDetailInfo().then((res) => {
        if (res.code === 200) {
          this.userScope = res.data;
        }
      });
    },
    getContractCount() {
      contractCountApi()
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.$store.commit("SET_USER_CONTRSCT_INFO", res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      // this.getUserInfoHandle()
    },
    toFlow() {
      this.$router.push({
        path: "/temp-create",
        query: {
          from: this.$route.fullPath.replace(/\?/, "!!"),
        },
      });
    },
    toConsole() {
      const consoleHref = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL) ? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL);
      return consoleHref;
    },
  },
};
</script>


<style lang="scss" scoped>
.space-layer {
  background: #F3F3F7;
  min-height: calc(100vh);
}

.space-content {
  margin-top: 20px;

  height: calc(100vh - 100px);

  .menu-content {
    display: flex;
    justify-content: space-between;
    height: 100%;

    .menu {
      width: 160px;
      // min-height: 818px;
      background: #fff;
      border-radius: 10px;
      overflow-y: auto;

      .el-menu-vertical {
        /deep/ .el-submenu__title {
          height: 60px;
          line-height: 60px;
          font-size: 16px;
          font-weight: 500;
          color: #1D2129;
          padding: 0 24px !important;
          background: none;
        }

        /deep/ .el-submenu__icon-arrow {
          font-size: 16px;
          font-weight: bold;
          color: #1D2129;
          padding: 1px;
        }

        /deep/ .el-menu-item {
          height: 40px;
          line-height: 40px;
          margin: 4px 0;
          padding-left: 24px !important;
          padding-right: 0;
          margin-right: 10px;
          min-width: unset;
          border-radius: 0px 10px 10px 0px;

          font-size: 14px;
          font-weight: 500;
          color: #4E5969;

          display: flex;
          align-items: center;
          justify-content: flex-start;

          &.is-active {
            background: #F0F5FF;
            color: #165DFF;

            .menu-icon {
              display: none;

              &.active {
                display: block;
              }
            }
          }

          &:hover {
            background: #F0F5FF;
          }
        }

        .menu-icon {
          width: 18px;
          height: 18px;
          margin-right: 14px;

          &.active {
            display: none;
          }
        }

        .menu-num {
          margin-left: 6px
        }

      }
    }

    .space-list {
      width: calc(100% - 168px);
      min-height: calc(100vh - 287px);
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
    }

  }
}






.space-info {
  width: 100%;
  height: 164px;
  background: rgba(255, 255, 255, 1);
  padding: 28px 79px 28px 29px;
  // box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    .left-top {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 18px;

      .user-img {
        width: 51px;
        height: 51px;
        margin-right: 16px;
      }

      .user-name {
        margin-right: 12px;
      }

      .user-auth {
        width: 48px;
        height: auto;
        margin-top: 2px;
      }
    }

    .left-bottom {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      padding-left: 67px;
      padding-bottom: 15px;
      color: #999999;

      &>div {
        margin-right: 22px;
      }

      .value {
        font-weight: bold;
        color: #333333;
        margin-left: 15px;
      }
    }

    .person-left-bottom {
      font-size: 16px;
      color: #999999;
      padding-left: 67px;

      &>div {
        margin-right: 22px;
        margin-top: 10px;
      }

      .value {
        font-weight: bold;
        color: #333333;
        margin-left: 15px;
      }
    }
  }

  .mid {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding-bottom: 15px;

    .mid-item {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #999999;

      .count {
        font-weight: bold;
        color: #333333;
        font-size: 21px;
        margin-bottom: 14px;
      }
    }

    .mid-item+.mid-item {
      margin-left: 67px;
    }
  }

  .right {
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .to-sign {
      width: 100px;
      height: 32px;
      background: linear-gradient(0deg,
          rgba(59, 178, 253, 1) 0%,
          rgba(15, 217, 242, 1) 99%);
      // box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.17);
      border-radius: 10px;
      text-align: center;
      display: block;
      line-height: 32px;
      color: #ffffff;
      font-size: 14px;
    }

    .to-console {
      margin-top: 30px;
      width: 100px;
      height: 32px;
      background: #ff6633;
      // box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.17);
      border-radius: 8px;
      color: #fff;
      text-align: center;
      border-radius: 10px;
      display: block;
      line-height: 32px;
      font-size: 14px;
    }
  }
}

.user-space-info .card {
  position: absolute;
  left: 99px;
  top: 78px;
  width: 700px;
}

.user-space-info .phone {
  position: absolute;
  left: 99px;
  top: 117px;
  width: 700px;
}

.user-space-info .card,
.user-space-info .phone {
  font-size: 16px;
  line-height: 16px;
}

.user-space-info .card span:nth-of-type(1),
.user-space-info .phone span:nth-of-type(1) {
  color: #999999;
  width: 65px;
  float: left;
}

.user-space-info .card span:nth-of-type(2),
.user-space-info .phone span:nth-of-type(2) {
  color: #333333;
  margin-left: 25px;
}

.company-meal {
  position: absolute;
  left: 528px;
  top: 64px;
  width: 100px;
  text-align: center;
}

.company-meal p:first-child,
.user-meal p:first-child {
  font-size: 26px;
  color: #333333;
  font-weight: 600;
}

.company-meal p:last-child,
.user-meal p:last-child {
  font-size: 16px;
  color: #999999;
}

.user-meal {
  position: absolute;
  left: 691px;
  top: 64px;
  text-align: center;
  width: 160px;
}

.user-menu-content {
  /* width: 1200px;
																																											    margin: 22px auto 0; */
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.user-menu {
  width: 230px;
  min-height: calc(100vh - 287px);
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
}



.first-menu {
  font-size: 16px;
}

.img1 {
  display: none;
  margin-left: -5px;
}

// .el-menu-item:hover,
// .el-menu-item:focus {
// 	background: #ffffff;
// }

// .el-menu-item:hover .menu-text,
// .el-menu-item:focus .menu-text {
// 	color: #333333;
// }

// .el-menu-item:focus .menu-num,
// .el-menu-item:hover .menu-num {
// 	color: #276ee8;
// }

.el-menu-item:hover .img1,
.el-menu-item:focus .img1,
.el-menu-item:active .img1,
.el-menu-item:visited .img1 {
  display: inline-block;
}

.el-menu-item:hover .img2,
.el-menu-item:focus .img2,
.el-menu-item:active .img2,
.el-menu-item:visited .img2 {
  display: none;
}

// /deep/ .el-submenu__title:hover {
// 	background: unset;
// }

// .is-active .el-menu-item {
// 	background: #ffffff;
// 	border: none;
// }

// .is-active .is-active .menu-text {
// 	color: #333333;
// }

.is-active .is-active .img1 {
  display: inline-block;
}

.is-active .is-active .img2 {
  display: none;
}

.el-menu-item.is-active {
  color: #3296fa;
  background-color: #ebf5ffaa;
}

.el-submenu .el-menu-item {
  // margin: 10px 15px;
  height: 45px;
  line-height: 45px;
}

/deep/ .el-menu-item-group__title {
  display: none;
}
</style>
